import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-object-group',
  templateUrl: './delete-object-group.component.html',
  styleUrls: ['./delete-object-group.component.css']
})
export class DeleteObjectGroupComponent implements OnInit {

  objectData: any = []

  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  groupId: any

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllGroupList()

  }


  onTableDataChange(event: any) {
    this.page = event;
    this.getAllGroupList();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllGroupList();
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllGroupList(){
    this.generic_service.getAllGroupList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteIdSelect(id:any){
    this.groupId = id
  }

  deleteGroup(){
    this.generic_service.deleteObjectGroupMaster(this.groupId).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllGroupList()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

}